export const SAVE_PCT_NOTIFIER_SETTINGS = "SAVE_PCT_NOTIFIER_SETTINGS"
export const SAVE_PCT_NOTIFIER_SETTINGS_SUCCESS = "SAVE_PCT_NOTIFIER_SETTINGS_SUCCESS"
export const GET_PCT_NOTIFIER_SETTINGS = "GET_PCT_NOTIFIER_SETTINGS"
export const GET_PCT_NOTIFIER_SETTINGS_SUCCESS = "GET_PCT_NOTIFIER_SETTINGS_SUCCESS"
export const SET_PCT_LOADING = "SET_PCT_LOADING"
export const SET_PCT_SUCCESS = "SET_PCT_SUCCESS"
export const GET_PCT_INFO = "GET_PCT_INFO"
export const GET_PCT_INFO_SUCCESS = "GET_PCT_INFO_SUCCESS"
export const MULTIPLE_STAR_PCT = "MULTIPLE_STAR_PCT"
export const MULTIPLE_STAR_PCT_SUCCESS = "MULTIPLE_STAR_PCT_SUCCESS"
export const MULTIPLE_UNSTAR_PCT = "MULTIPLE_UNSTAR_PCT"
export const MULTIPLE_UNSTAR_PCT_SUCCESS = "MULTIPLE_UNSTAR_PCT_SUCCESS"
export const MULTIPLE_HIDE_PCT = "MULTIPLE_HIDE_PCT"
export const MULTIPLE_HIDE_PCT_SUCCESS = "MULTIPLE_HIDE_PCT_SUCCESS"
export const MULTIPLE_UNHIDE_PCT = "MULTIPLE_UNHIDE_PCT"
export const MULTIPLE_UNHIDE_PCT_SUCCESS = "MULTIPLE_UNHIDE_PCT_SUCCESS"
export const GET_PCT_INFO_LIST = "GET_PCT_INFO_LIST"
export const GET_PCT_INFO_LIST_SUCCESS = "GET_PCT_INFO_LIST_SUCCESS"
export const STAR_PCT_TARGET = "STAR_PCT_TARGET"
export const UNSTAR_PCT_TARGET = "UNSTAR_PCT_TARGET"
export const HIDE_PCT_TARGET = "HIDE_PCT_TARGET"
export const UNHIDE_PCT_TARGET = "UNHIDE_PCT_TARGET"
export const CHANGE_PCT_NOTIFIER = "CHANGE_PCT_NOTIFIER"
export const SET_PCT_RESULTS = "SET_PCT_RESULTS"
export const UNLOCK_PCT = "UNLOCK_PCT"
export const UNLOCK_PCT_SUCCESS = "UNLOCK_PCT_SUCCESS"
export const GET_PCT_INFO_LIST_SUCCESS_UNLOCK = "GET_PCT_INFO_LIST_SUCCESS_UNLOCK"
export const DOWNLOAD_PCT_EXCEL = "DOWNLOAD_PCT_EXCEL"
export const DOWNLOAD_PCT_EXCEL_SUCCESS = "DOWNLOAD_PCT_EXCEL_SUCCESS"
export const DOWNLOAD_MULTIPLE_PCT_EXCEL = "DOWNLOAD_MULTIPLE_PCT_EXCEL"
export const DOWNLOAD_MULTIPLE_PCT_EXCEL_SUCCESS = "DOWNLOAD_MULTIPLE_PCT_EXCEL_SUCCESS"
export const DOWNLOAD_PCT_PDF = "DOWNLOAD_PCT_PDF"
export const DOWNLOAD_PCT_PDF_SUCCESS = "DOWNLOAD_PCT_PDF_SUCCESS"
export const DOWNLOAD_MULTIPLE_PCT_PDF = "DOWNLOAD_MULTIPLE_PCT_PDF"
export const DOWNLOAD_MULTIPLE_PCT_PDF_SUCCESS = "DOWNLOAD_MULTIPLE_PCT_PDF_SUCCESS"
export const PREVIEW_PCT_EMAIL = "PREVIEW_PCT_EMAIL"
export const PREVIEW_PCT_EMAIL_SUCCESS = "PREVIEW_PCT_EMAIL_SUCCESS"
export const SET_PREVIEW_PCT_EMAIL = "SET_PREVIEW_PCT_EMAIL"
export const SEND_PCT_EMAIL = "SEND_PCT_EMAIL"
export const SEND_PCT_EMAIL_SUCCESS = "SEND_PCT_EMAIL_SUCCESS"
export const CHANGE_SENT_PCT_RESULT = "CHANGE_SENT_PCT_RESULT"
export const SET_PCT_SENT_SUCCESS = "SET_PCT_SENT_SUCCESS"
export const SET_UPGRADE_ALERT_MESSAGE = "SET_UPGRADE_ALERT_MESSAGE"
export const SET_PCT_SETTINGS = "SET_PCT_SETTINGS"